import { render, staticRenderFns } from "./ShipmentBatchesList.vue?vue&type=template&id=b04cf9be&scoped=true"
import script from "./ShipmentBatchesList.vue?vue&type=script&lang=js"
export * from "./ShipmentBatchesList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentBatchesList.vue?vue&type=style&index=0&id=b04cf9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04cf9be",
  null
  
)

export default component.exports